import React, { useState } from "react";
import styles from "../styles.module.scss";
import useGetDealers from "@Hooks/useDealers";

interface DealerSelectSelectProps {
  dealerId: string | null;
  onSelect: (dealerId: string | null) => void;
  className?: string;
}

const DealerSelect: React.FC<DealerSelectSelectProps> = ({
  onSelect,
  className,
  dealerId,
}) => {
  const { data: dealers } = useGetDealers();

  const [selectDealerId, setSelectedDealerId] = useState<string | null>(
    "All Dealers"
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSelect = () => {
    console.log("selectDealerId", selectDealerId);
    if (selectDealerId === "All Dealers") onSelect(null);
    else onSelect(selectDealerId);
    setIsOpen(false);
  };

  const getDisplayText = () => {
    const selectedDealer = dealers?.find((dealer) => dealer._id === dealerId);
    return dealerId ? selectedDealer?.data?.info?.displayName : "All Dealers";
  };

  return (
    <div className={`${styles.selectContainer} ${className || ""}`}>
      <div className={styles.selectButton} onClick={() => setIsOpen(!isOpen)}>
        <span>{getDisplayText()}</span>
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
        >
          <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>
            <div className={styles.yearSelect}>
              <label>Dealer</label>
              <select
                value={selectDealerId ?? "Select Dealer"}
                onChange={(e) => setSelectedDealerId(e.target.value)}
              >
                <option value="All Dealers">All Dealers</option>

                {(dealers || []).map((dealer) => (
                  <option key={dealer._id} value={dealer._id}>
                    {dealer?.data?.info?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className={styles.dropdownFooter}>
            <button
              className={styles.cancelButton}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
            <button className={styles.applyButton} onClick={handleSelect}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerSelect;
